var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _connector;
import { subscription } from '@aragon/connect-core';
import { formatBn } from '../helpers';
export default class Staking {
    constructor(data, connector) {
        _connector.set(this, void 0);
        __classPrivateFieldSet(this, _connector, connector);
        this.id = data.id;
        this.user = data.user;
        this.tokenId = data.tokenId;
        this.tokenSymbol = data.tokenSymbol;
        this.tokenDecimals = data.tokenDecimals;
        this.available = data.available;
        this.locked = data.locked;
        this.challenged = data.challenged;
        this.total = data.total;
    }
    async disconnect() {
        await __classPrivateFieldGet(this, _connector).disconnect();
    }
    get formattedTotalAmount() {
        return formatBn(this.total, this.tokenDecimals);
    }
    get formattedAvailableAmount() {
        return formatBn(this.available, this.tokenDecimals);
    }
    get formattedLockedAmount() {
        return formatBn(this.locked, this.tokenDecimals);
    }
    get formattedChallengedAmount() {
        return formatBn(this.challenged, this.tokenDecimals);
    }
    async token() {
        return __classPrivateFieldGet(this, _connector).ERC20(this.tokenId);
    }
    onToken(callback) {
        return subscription(callback, (callback) => __classPrivateFieldGet(this, _connector).onERC20(this.tokenId, callback));
    }
}
_connector = new WeakMap();
//# sourceMappingURL=Staking.js.map